module.exports = __webpack_public_path__ + "img/flag.564fbed3.svg";